import { format } from 'date-fns';

interface HMS {
	hours: number;
	minutes: number;
	seconds: number;
}

export const secondsToHMS = (seconds: number): HMS => {
	const totalSeconds = parseInt(seconds.toString(), 10);

	const hours = Math.floor(totalSeconds / 3600);
	const minutes = Math.floor((totalSeconds % 3600) / 60);
	const remainingSeconds = totalSeconds % 60;

	return {
		hours,
		minutes,
		seconds: remainingSeconds,
	};
};

export const formatHMS = (hms: HMS): string => {
	return format(
		new Date(0, 0, 0, hms.hours, hms.minutes, hms.seconds),
		'HH:mm:ss'
	);
};
